import { render, staticRenderFns } from "./InvoiceEditor.vue?vue&type=template&id=596c8591&"
import script from "./InvoiceEditor.vue?vue&type=script&lang=js&"
export * from "./InvoiceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports